<script>
  export default {
    data: function () {
      return {
        destroy : 0,
        upload_files : []
      }
    },
    props: {
      instance: null,
      topic: Object, 
      index: Number,
      base_input_name: String,
    },
    computed: {
      _style: function(){
        if (this.isDestroyed){
          return {
            'display': 'none'
          }
        }else{
          return {

          }
        }
      },
      isDestroyed: function(){
        if (this.$data.destroy == 1){
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      deleteInstance: function(){
        this.$data.destroy = 1;
      },
      inputName: function(name, {isArray=false}={}){
        if(isArray == true){
          return `${this.base_input_name}[${this.index}][${name}][]`
        }
        else{
          return `${this.base_input_name}[${this.index}][${name}]`
        }
      },
      processFile(event) {
        this.upload_files.push(event.target);
      },
      formatFileSize(bytes, decimalPoint) {
        if(bytes == 0) return '0 Bytes';
        var k = 1000,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
      }
    }
  }
</script>